/**
 * نوار ورود/خروج اطلاعات — مشترک برای همهٔ بخش‌ها
 * props:
 *   templateUrl   — آدرس دانلود قالب (اختیاری)
 *   templateLabel — عنوان قالب
 *   onImport(file)— callback ورود اطلاعات (اختیاری)
 *   loading
 *   result        — نتیجهٔ ورود
 *   accept        — فرمت‌های مجاز
 *   exportUrl     — آدرس خروجیِ اکسل (اختیاری → دکمهٔ «خروجی اطلاعات»)
 *   exportParams  — پارامترهای query خروجی
 *   exportLabel   — برچسب دکمهٔ خروجی (پیش‌فرض «خروجی اطلاعات»)
 *   importLabel   — برچسب دکمهٔ ورود (پیش‌فرض «ورود اطلاعات»)
 */
import React, { useState } from "react";
import { Button, Upload, Space, Tooltip, message } from "antd";
import Alert from "./GxAlert";
import { DownloadOutlined, UploadOutlined, CheckCircleOutlined, ExportOutlined } from "@ant-design/icons";
// دانلود با کلاینتِ احرازشده — قبلاً لینکِ خام بود و روی مسیرهای گیت‌دار ۴۰۱ می‌داد
import { downloadFile } from "../api/client";
import ExportButton from "./ExportButton";


export default function ImportExportBar({
  templateUrl, templateLabel, onImport, loading, result, accept = ".xlsx,.xls",
  exportUrl, exportParams, exportLabel = "خروجی اطلاعات", importLabel = "ورود اطلاعات",
}) {
  const [tplBusy, setTplBusy] = useState(false);
  const getTemplate = async () => {
    setTplBusy(true);
    try { await downloadFile(templateUrl, `template-${templateLabel || "file"}.xlsx`); }
    catch { message.error("دانلودِ قالب ناموفق بود"); }
    setTplBusy(false);
  };
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Space wrap>
        {templateUrl && (
          <Tooltip title="دانلود فایل نمونه — همین فرمت را پر کن و وارد کن">
            <Button icon={<DownloadOutlined />} onClick={getTemplate} loading={tplBusy}>
              دانلود قالب {templateLabel}
            </Button>
          </Tooltip>
        )}
        {onImport && (
          <Upload
            beforeUpload={() => false}
            onChange={({ file }) => { if (file.status !== "removed") onImport(file); }}
            showUploadList={false}
            accept={accept}
          >
            <Button icon={<UploadOutlined />} type="primary" loading={loading}>
              {importLabel}
            </Button>
          </Upload>
        )}
        {exportUrl && (
          <ExportButton url={exportUrl} params={exportParams || {}} label={exportLabel}
            icon={<ExportOutlined />} color="#1F4E79" />
        )}
      </Space>
      {result && (
        <Alert
          type={result.type || "success"}
          icon={<CheckCircleOutlined />}
          message={result.message}
          showIcon
          closable
        />
      )}
    </Space>
  );
}
